import { Link } from 'react-router-dom';
import { useState } from 'react';

interface AddressCardProps {
  name: string;
  url: string;
  type: string;
  status: string;
  speed: string;
  region: string;
  badge: string;
  index: number;
}

function AddressCard({ name, url, type, status, speed, region, badge, index }: AddressCardProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback
    }
  };

  const statusMap: Record<string, { color: string; text: string }> = {
    online: { color: 'bg-accent-500', text: '在线' },
    standby: { color: 'bg-secondary-400', text: '待命' },
  };

  const badgeColors: Record<string, string> = {
    '推荐': 'bg-primary-500',
    '国内首选': 'bg-primary-500',
    '紧急': 'bg-red-500',
  };

  const badgeBg = badgeColors[badge] || 'bg-primary-500';

  return (
    <div className="group bg-background-50 rounded-xl border border-background-200 p-5 hover:border-primary-300 transition-all duration-300 cursor-pointer">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2.5">
          <div className={`w-2.5 h-2.5 rounded-full ${statusMap[status]?.color || 'bg-secondary-400'}`}></div>
          <span className="font-heading font-semibold text-foreground-900 text-sm">
            {name}
          </span>
        </div>
        <div className="flex items-center gap-2">
          {badge && (
            <span className={`${badgeBg} text-background-50 text-[10px] px-2 py-0.5 rounded-full font-medium whitespace-nowrap`}>
              {badge}
            </span>
          )}
          {type === 'primary' && (
            <span className="bg-primary-100 text-primary-700 text-[10px] px-2 py-0.5 rounded-full font-medium whitespace-nowrap">
              主入口
            </span>
          )}
          {type === 'emergency' && (
            <span className="bg-red-100 text-red-700 text-[10px] px-2 py-0.5 rounded-full font-medium whitespace-nowrap">
              应急
            </span>
          )}
        </div>
      </div>

      <div className="bg-background-100 rounded-lg px-3 py-2.5 mb-3">
        <p className="text-xs text-foreground-600 font-mono break-all">{url}</p>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-global-line"></i>
            {region}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-speed-up-line"></i>
            {speed}
          </span>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleCopy();
          }}
          className="flex items-center gap-1 text-xs font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {copied ? (
            <>
              <i className="ri-check-line"></i>
              已复制
            </>
          ) : (
            <>
              <i className="ri-file-copy-line"></i>
              复制
            </>
          )}
        </button>
      </div>
    </div>
  );
}

export default AddressCard;